import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import lottie, {AnimationConfigWithData, AnimationConfigWithPath, AnimationItem} from 'lottie-web';
import {computed, onBeforeUnmount, onMounted, onUnmounted, ref} from "vue";


const __default__ = {
    name: "LottiePlayer"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    options: {},
    height: {},
    width: {}
  },
  emits: ["created", "loop-complete", "complete"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let lavContainer = ref<HTMLDivElement>();

let style = computed(() => ({
    width: props.width ? `${props.width}px !important` : '100% !important',
    height: props.height ? `${props.height}px !important` : '100% !important',
    overflow: 'hidden !important',
    margin: '0 auto !important'
}));

let anim = ref<AnimationItem>();

onMounted(() => {
    anim.value = lottie.loadAnimation({
        container: lavContainer.value,
        renderer: 'svg',
        loop: props.options.loop !== false,
        autoplay: props.options.autoplay !== false,
        animationData: (props.options as AnimationConfigWithData).animationData,
        path: (props.options as AnimationConfigWithPath).path,
        rendererSettings: props.options.rendererSettings
    });
    anim.value.addEventListener("loopComplete", () => {
        emits('loop-complete', anim.value);
    });
    anim.value.addEventListener("complete", () => {
        emits('complete', anim.value);
    });
    emits('created', anim.value);
});

onUnmounted(() => setTimeout(() => anim.value?.destroy(), 2000));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "lavContainer",
    ref: lavContainer,
    style: _normalizeStyle(_unref(style))
  }, null, 4))
}
}

})